class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    const continueShopping = this.querySelector('.cart-notification__continue');
    if (continueShopping) {
      continueShopping.addEventListener('click', this.close.bind(this));
    }
  }

  open() {
    if (!this.notification) {
      this.notification = document.getElementById('cart-notification');
    }
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.removeEventListener('click', this.onBodyClick);
    /* Defer so the Add to cart click does not bubble here and close immediately */
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClick);
    }, 0);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!this._initialized) this.connectedCallback();

    const addedItems = Array.isArray(parsedState.items) ? parsedState.items : [];
    this.cartItemKeys = addedItems.map((item) => item.key).filter(Boolean);
    this.cartItemKey = parsedState.key || this.cartItemKeys[this.cartItemKeys.length - 1];

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;

      if (section.id === 'cart-icon-bubble') {
        const fab = document.getElementById('cart-icon-bubble');
        if (fab) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const section =
            doc.querySelector('#shopify-section-cart-icon-bubble') ||
            doc.querySelector('.shopify-section');
          fab.innerHTML = section ? section.innerHTML : '';
        }
        return;
      }

      if (section.id === 'cart-notification-product') {
        this.renderCartNotificationProducts(sectionHtml);
        return;
      }

      const target = document.getElementById(section.id);
      if (!target) return;

      if (section.selector) {
        const inner = target.querySelector(section.selector);
        if (inner) {
          inner.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        } else {
          target.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        }
      } else {
        target.innerHTML = this.getSectionInnerHTML(sectionHtml);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  renderCartNotificationProducts(sectionHtml) {
    const container = document.getElementById('cart-notification-product');
    if (!container) return;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const root = doc.querySelector('.shopify-section');
    if (!root) return;

    const keys = this.cartItemKeys.length ? this.cartItemKeys : [this.cartItemKey].filter(Boolean);
    let html = '';

    keys.forEach((key) => {
      const line = doc.getElementById(`cart-notification-product-${key}`);
      if (line) html += line.outerHTML;
    });

    container.innerHTML = html || root.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (selector === '.shopify-section' || !selector) {
      const section =
        doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      return section ? section.innerHTML : '';
    }
    const root = doc.querySelector('.shopify-section');
    if (!root) return '';
    const target = root.querySelector(selector) || root;
    return target.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest('cart-notification') &&
      !target.closest('#cart-notification')
    ) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
